module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/sakae_point3_2-627a050edd78e406da420ddecb81c88f.jpg";